import {createSlice} from '@reduxjs/toolkit';


interface state{
  authenticated:boolean
}

const intialState:state = {
  authenticated:false
}

const authSlice = createSlice({
  name:'auth',
  initialState:intialState,
  reducers:{

  }
});


export default authSlice.reducer;